import { createReducer } from '@reduxjs/toolkit';

import { TYPES } from '../../common/constants';

const fetchTypeaheadResults = (typeahead, { value }) => {
  return {
    ...typeahead,
    value,
  };
};

const fetchTypeaheadResultsDone = (typeahead, { payload }) => {
  return {
    ...typeahead,
    results: payload,
  };
};

const clearGlobalSearch =( typeahead )=>{
  return {
    ...typeahead,
    results:[],
    value:''
  }
}


const initialState = {};

export default createReducer(initialState, {
  [TYPES.FETCH_TYPEAHEAD_RESULTS]: fetchTypeaheadResults,
  [TYPES.FETCH_TYPEAHEAD_RESULTS_DONE]: fetchTypeaheadResultsDone,
  [TYPES.CLEAR_GLOBAL_SEARCH]:clearGlobalSearch
});
